const statuses = state => state.statuses
const statusesById = state => {
  let statuses = JSON.parse(JSON.stringify(state.statuses))

  return statuses.reduce((object, item) => {
    return {
      ...object,
      [item[item.id]]: item.name,
    }
  }, {})
}

export default {
  statuses,
  statusesById
}
